// extracted by mini-css-extract-plugin
module.exports = {"root":"Administration_root__28DcX","rootSpin":"Administration_rootSpin__2v7bo","toolbar":"Administration_toolbar__1KYPx"};